type Reason = "wrong-tenant" | "missing-role" | "auth-error";

const COPY: Record<Reason, { title: string; body: string }> = {
  "wrong-tenant": {
    title: "Not available for your organization",
    body:
      "This tool is restricted to the OpenSesame master-platform tenant. If you should have access, contact the CSR team to confirm your organization assignment."
  },
  "missing-role": {
    title: "Access not granted",
    body:
      "Your account is on the right tenant but doesn't carry the `next.viewer` role. Request access from the CSR team and try again."
  },
  "auth-error": {
    title: "Sign-in could not complete",
    body: "Try again. If the problem persists, reach the CSR team."
  }
};

export function Forbidden({
  reason,
  detail,
  onSignOut,
  onRetry
}: {
  reason: Reason;
  detail?: string;
  onSignOut?: () => void;
  onRetry?: () => void;
}) {
  const copy = COPY[reason];

  return (
    <div className="flex min-h-screen items-center justify-center p-8">
      <div className="max-w-md text-center">
        <p className="text-[10px] uppercase tracking-[0.25em] text-[color:var(--color-brand-orange)]">
          OpenSesame
        </p>
        <h1 className="mt-3 text-2xl font-semibold text-white">{copy.title}</h1>
        <p className="mt-4 text-sm leading-relaxed text-white/70">{copy.body}</p>
        {detail && (
          <p className="mt-3 text-xs text-white/40 font-mono">{detail}</p>
        )}
        <div className="mt-6 flex justify-center gap-3">
          {onRetry && (
            <button
              type="button"
              onClick={onRetry}
              className="rounded-lg px-4 py-2 text-sm font-medium text-white"
              style={{ backgroundColor: "#F28132" }}
            >
              Try again
            </button>
          )}
          {onSignOut && (
            <button
              type="button"
              onClick={onSignOut}
              className="rounded-lg border border-white/20 px-4 py-2 text-sm text-white/80 hover:bg-white/5"
            >
              Sign out
            </button>
          )}
        </div>
      </div>
    </div>
  );
}
